<template>
    <div class="modal fade text-left" tabindex="-1" role="dialog" aria-labelledby="myModalLabel1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title " id="myModalLabel17">Creditfixrr Attack</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="container">
                        <div class="row">
                            <div
                                class="col-sm-12 col-md-6 col-lg-6"
                                style="
                                    border-top: 1px solid #fffff !important;
                                    border-bottom:1px solid #f6f6f6 !important
                                "
                            >
                                <div class="d-flex">
                                    <div class="d-flex justify-content-center align-items-center w-25">
                                        <img class="w-100 rounded" src="https://test-creditfixrr-spaces.nyc3.digitaloceanspaces.com/dispute-letter-covers/bulldozer%20%20Attack.png" alt="image" >
                                    </div>
                                    <div class="w-75 px-1 py-2">
                                        <h3 class="mb-0">Bulldozer</h3>
                                        <p class="mb-0">Attack on all items on the credit report</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-6" style="border-top: 1px solid #fffff !important; border-left:1px solid #f6f6f6 !important; border-bottom:1px solid #f6f6f6 !important">
                                <div class="d-flex">
                                    <div class="d-flex justify-content-center align-items-center w-25">
                                        <img class="w-100 rounded" src="https://test-creditfixrr-spaces.nyc3.digitaloceanspaces.com/dispute-letter-covers/Jack%20Hammer%20%20Attack.png" alt="image" >
                                    </div>
                                    <div class="w-75 px-1 py-2">
                                        <h3 class="mb-0">Jack Hammer</h3>
                                        <p class="mb-0">
                                            Creates an Attack letter for all negative items and Personal Information. This Metro 2 Attack does not disputes Inquires.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div
                                class="col-sm-12 col-md-6 col-lg-6"
                                style="
                                    border-top: 1px solid #fffff !important;
                                    border-bottom:1px solid #f6f6f6 !important
                                "
                            >
                                <div class="d-flex">
                                    <div class="d-flex justify-content-center align-items-center w-25">
                                        <img class="w-100 rounded" src="https://test-creditfixrr-spaces.nyc3.digitaloceanspaces.com/dispute-letter-covers/Scissor%20Lift%20Attack.png" alt="image" >
                                    </div>
                                    <div class="w-75 px-1 py-2">
                                        <h3 class="mb-0">Scissor Lift</h3>
                                        <p class="mb-0">Creates a letter for each TYPE (Personal Info, Inquiries, Derogatories, Late Payments etc)</p>
                                    </div>
                                </div>
                            </div>
                            <div
                                class="col-sm-12 col-md-6 col-lg-6"
                                style="
                                    border-top: 1px solid #fffff !important;
                                    border-left:1px solid #f6f6f6 !important;
                                "
                            >
                                <div class="d-flex">
                                    <div class="d-flex justify-content-center align-items-center w-25">
                                        <img class="w-100 rounded" src="https://test-creditfixrr-spaces.nyc3.digitaloceanspaces.com/dispute-letter-covers/Cement%20%20Attack.png" alt="image" >
                                    </div>
                                    <div class="w-75 px-1 py-2">
                                        <h3 class="mb-0">
                                            Cement Attack
                                        </h3>
                                        <p class="mb-0">
                                            Creates an Attack letter for all negative items, Inquires and Personal Information.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="table-responsive mt-2">
                        <table class="table table-success table-hover table-striped mb-0">
                            <thead class="thead-primary text-center">
                                <tr>
                                    <th>
                                        Attack Number
                                    </th>                                                                
                                    <th>
                                        Attack Name
                                    </th>                                                               
                                    <th>
                                        Mail Type
                                    </th>
                                    <!-- <th>
                                        RTS
                                    </th> -->
                                    <th>
                                        Letter Color
                                    </th>
                                    <th>
                                        Letter Sides
                                    </th>                                                                
                                    <th>
                                        Attack Frequency
                                    </th>
                                </tr>
                            </thead>
                            <tbody class="table-striped">
                                <tr class="text-center">
                                    <td>Round 1</td>
                                    <td>Cement Attack</td>
                                    <td>Certified</td>
                                    <!-- <td>Y</td> -->
                                    <td>Yes</td>
                                    <td>Single-Sided</td>
                                    <td>Day 1</td>
                                </tr>
                                <tr class="text-center">
                                    <td>Round 2</td>
                                    <td>Jack Hammer Attack</td>
                                    <td>First Class</td>
                                    <!-- <td>N</td> -->
                                    <td>No</td>
                                    <td>Double-Sided</td>
                                    <td>Day 36</td>
                                </tr>
                                <tr class="text-center">
                                    <td>Round 3</td>
                                    <td>Cement Attack</td>
                                    <td>First Class</td>
                                    <!-- <td>N</td> -->
                                    <td>No</td>
                                    <td>Double-Sided</td>
                                    <td>Day 71</td>
                                </tr>
                                <tr class="text-center">
                                    <td>Round 4</td>
                                    <td>Bulldozer Attack</td>
                                    <td>First Class</td>
                                    <!-- <td>N</td> -->
                                    <td>No</td>
                                    <td>Double-Sided</td>
                                    <td>Day 106</td>
                                </tr>
                                <tr class="text-center">
                                    <td>Round 5</td>
                                    <td>Cement Attack</td>
                                    <td>First Class</td>
                                    <!-- <td>N</td> -->
                                    <td>No</td>
                                    <td>Double-Sided</td>
                                    <td>Day 141</td>
                                </tr>
                                <tr class="text-center">
                                    <td>Round 6</td>
                                    <td>Sizzor Lift Attack</td>
                                    <td>First Class</td>
                                    <!-- <td>N</td> -->
                                    <td>Yes</td>
                                    <td>Single-Sided</td>
                                    <td>Day 176</td>
                                </tr>
                                <tr class="text-center">
                                    <td>Round 7</td>
                                    <td>Jack Hammer Attack</td>
                                    <td>First Class</td>
                                    <!-- <td>N</td> -->
                                    <td>Yes</td>
                                    <td>Double-Sided</td>
                                    <td>Day 211</td>
                                </tr>
                                <tr class="text-center">
                                    <td>Round 8</td>
                                    <td>Jack Hammer Attack</td>
                                    <td>First Class</td>
                                    <!-- <td>N</td> -->
                                    <td>No</td>
                                    <td>Double-Sided</td>
                                    <td>Day 246</td>
                                </tr>
                                <tr class="text-center">
                                    <td>Round 9</td>
                                    <td>Jack Hammer Attack</td>
                                    <td>First Class</td>
                                    <!-- <td>Y</td> -->
                                    <td>Yes</td>
                                    <td>Double-Sided</td>
                                    <td>Day 281</td>
                                </tr>
                                <tr class="text-center">
                                    <td>Round 10</td>
                                    <td>Sizzor Lift Attack</td>
                                    <td>First Class</td>
                                    <!-- <td>N</td> -->
                                    <td>No</td>
                                    <td>Double-Sided</td>
                                    <td>Day 316</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="container card mt-2">
                        <h3 class="text-center">
                            Creditfixrr Attack Guide
                        </h3>
                        <div class="row border-light">
                            <div class="text-center d-flex justify-content-center align-items-center col-2 bg-light border-bottom-white">
                                1
                            </div>
                            <div class="col-10 py-2">
                                If your “Personal Information” is incorrect on the credit report. Always send a “Personal Information letter” 5 days before your next attack until all personal information is correct. Send the “Personal Information” letter first class mail, black and white and single-sided.
                            </div>
                        </div>
                        <div class="row border-light">
                            <div class="text-center d-flex justify-content-center align-items-center col-2 bg-light border-bottom-white">
                                2
                            </div>
                            <div class="col-10 py-2">
                                Do not dispute any inquiries associated with an open-account your the credit report. You risk the creditor closing the account associated with that inquiry.
                            </div>
                        </div>
                        <div class="row border-light">
                            <div class="text-center d-flex justify-content-center align-items-center col-2 bg-light border-bottom-white">
                                3
                            </div>
                            <div class="col-10 py-2">
                                If 35 days have passed since the last attack and you haven’t received a response back from the credit bureaus, Send a “Failure To Respond” letter to the credit bureaus. After sending wait 5 days then continue with your next attack sequence. Send a “Failure To Respond” letter certified mail, black and white and double-sided.
                            </div>
                        </div>
                        <div class="row border-light">
                            <div class="text-center d-flex justify-content-center align-items-center col-2 bg-light border-bottom-white">
                                4
                            </div>
                            <div class="col-10 py-2">
                                For any accounts, the credit bureaus claimed as “Verified” send the “Method of Verification” letter in response. After sending wait 5 days then continue with your next attack sequence. Send the “Method of Verification” letter first-class, black and white and double-sided.
                            </div>
                        </div>
                        <div class="row border-light">
                            <div class="text-center d-flex justify-content-center align-items-center col-2 bg-light border-bottom-white">
                                5
                            </div>
                            <div class="col-10 py-2">
                                When dealing with debt collectors send a separate “Debt Validation” Letter to all debt collectors for each account. Send this certified mail, black and white and double-sided. For debt-Collectors who are harrassing you by phone or mail. You may also send them a “Cease and Desist & Refusal to pay” letter along with a “Debt Validation” Letter. It is recommended that you proactively send one of these letters to all debt collectors listed on the credit report. Note: Debt Validation is asking for more details about the debt while communicating only via the mail. Cease and Desist & Refusal To Pay is best for stopping all forms of communication and setting a debt collector up for a lawsuit for FDCPA violations.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useReportStore } from '../../stores/ReportStore.js'
    export default {
        components: {
        },
        setup(props) {
            return {
                reportStore: useReportStore()
            }
        },
        methods: {
        },
        computed: {
           
        }
    }
</script>
